import { cva, type VariantProps } from "class-variance-authority";
import React from "react";

import { cn } from "@/utils/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-sm px-1.5 py-1 text-xs font-medium",
  {
    variants: {
      variant: {
        accent: "bg-accent-pink-500 text-white",
        default: "bg-primary-500 text-white",
        secondary: "bg-muted text-foreground",
        overlay: "bg-gray-900/75 text-white",
        success:
          "bg-green-200 text-success-900 dark:bg-green-900 dark:text-success-200",
        destructive:
          "bg-danger-100 text-danger-600 dark:bg-danger-900 dark:text-danger-200",
      },
    },
    defaultVariants: {
      variant: "accent",
    },
  },
);

type BadgeVariants = VariantProps<typeof badgeVariants>;
type BadgeVariant = NonNullable<BadgeVariants["variant"]>;

interface BadgeProps extends React.ComponentProps<"span">, BadgeVariants {}

/** Badge label for status, counts, and metadata. */
const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <span
    data-slot="badge"
    data-testid="badge"
    className={cn(badgeVariants({ variant }), className)}
    {...props}
  />
);

export { Badge as default, Badge, badgeVariants, type BadgeVariant };
